<template>
  <div>
    <abstractTable :columns="invoicesColumns" :data="computedInvoices"
                   :classes="'ui tablet very compact center aligned very basic celled table'"
                   :dataPerPage="10" :paginationEnable="true"
                   style="padding-top: 20px" :paginationNextButtonText="$t('next')"
                   :paginationFirstPageButtonText="$t('first')"
                   :paginationLastPageButtonText="$t('last')"
                   :paginationPervButtonText="$t('previous')" v-if="computedInvoices.length">

      <template slot="table-column">
        <th> {{ $t('actions') }} </th>
      </template>

      <template slot="table-row-after" slot-scope="props">
        <td style="width: 78px">
          <div class="ui blue very compact mini button" style="background-color: #092442"
                @click="props.row.id.functionality()">
            {{ $t('show') }}
          </div>
        </td>
      </template>
    </abstractTable>

    <div class="ui placeholder segment" style="margin-bottom: 50px" v-else>
      <div class="ui icon header" style="color: #092442">
        <i class="dont icon"></i>
        No purchased invoices neither selling invoices have been made yet.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default
  },
  props: {
    item: { type: Object, required: true },
    suppliers: { type: Array, default: () => [] }
  },
  computed: {
    invoicesColumns () {
      return [
        { header: 'Invocie Id', fieldName: 'id', show: true, html: true },
        { header: 'Real Invoice Number', fieldName: 'realNumber', show: true },
        { header: 'System Invoice Number', fieldName: 'systemNumber', show: true },
        { header: 'Recipient Name', fieldName: 'recipient', show: true },
        { header: 'Invoice Type', fieldName: 'invoiceType', show: true },
        { header: 'Company', fieldName: 'companyName', show: true },
        { header: 'Purchased Date', fieldName: 'date', show: true }
      ]
    },
    invoices () {
      return window._.map(window._.groupBy(this.item.invoices, 'id'), invoice => (invoice[0]))
    },
    computedInvoices () {
      let formlatedInvoices = []

      let getCompany = branchId => {
        return window._.find(this.suppliers, supplier => {
          return supplier.branch.id === branchId
        }).company
      }

      window._.each(this.invoices, invoice => {
        let company = getCompany(invoice.branch_id)
        formlatedInvoices.push({
          id: {
            functionality: () => {
              this.navigateTo('Show_Invoice', { key: 'params', value: { id: invoice.id } })
            },
            value: `<a style="cursor: pointer; text-decoration:underline;">${invoice.id}</a>`
          },
          recipient: invoice.recipient.name,
          realNumber: invoice.real_number || '-',
          systemNumber: this.displaySystemCode(invoice.system_number),
          date: window.moment(invoice.date).format('DD/MM/YYYY hh:mm a'),
          companyName: this.suppliers.length > 0 ? company.name : '-',
          invoiceType: invoice.invoice_type.name
        })
      })

      return formlatedInvoices
    }
  },
  methods: {
    displaySystemCode (code) {
      if (code.length < 8) {
        return '0'.repeat(8 - code.length) + code
      }

      return code
    }
  }

}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/inventory_system/items/item_components/InvoicesPart.vue